import React from 'react';
import { styled } from '@mui/system';
import colors from '../../../../theme/emotion/colors';

const StyledBackButton = styled('button')({
  position: 'fixed',
  top: '1rem',
  left: '1rem',
  background: 'transparent',
  border: 'none',
  fontSize: '1.5rem',
  cursor: 'pointer',
  padding: '0.5rem',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.primary.dark,
  zIndex: 20,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  '&::before': {
    content: '"←"',
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
});

interface OnboardingBackButtonProps {
  onClick: () => void;
  'aria-label'?: string;
}

const OnboardingBackButton: React.FC<OnboardingBackButtonProps> = ({ 
  onClick, 
  'aria-label': ariaLabel = 'Go back' 
}) => {
  return <StyledBackButton onClick={onClick} aria-label={ariaLabel} />;
};

export default OnboardingBackButton; 